import { useState, useEffect } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField, NullableInput} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const CreditVendorForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [vendorOptions, setVendorOptions] = useState([])

    const [formData, setFormData] = useState({
        vendor_id: "",
        credit: "",
        remark: "",
        date: new Date().toISOString().slice(0, 10),
    })
    const {vendor_id, credit, remark, date} = formData

    const navigate = useNavigate()

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const loadOptions = async (url, query, setOptions) => {
        try {
            const params = { q: query };

            const response = await Server.get(`/options/${url}`, { params });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {vendor_id, credit, remark, date}
        CreditVendor(payload)
    }
    
    // credit vendor
    const CreditVendor = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/vendors/credit', payload)
            toast.success(response.data?.detail)
            navigate('/account-payable')
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Credit Vendor Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <AsyncSelectField
                                name="vendor_id"
                                label="Vendor"
                                value={vendor_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('vendors', query, setVendorOptions)}
                                options={vendorOptions}
                                placeholder="Start typing to search..."
                                error={errors.vendor_id}
                            />
                        </div>
                        <div className="col-md-6">
                            <InputField
                                placeholder="Credit"
                                name="credit"
                                type="number"
                                label="Amount"
                                value={credit}
                                onChange={onChange}
                                error={errors.credit}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                        <div className="col-md-8">
                            <NullableInput
                                placeholder="Remark (Optional)"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Transaction" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default CreditVendorForm
